import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import ModalList from './ModalList';
import StaticMap from '../StaticMap';

const ModalCustomerDetail = ({ lookupKey, view }) => {
  const [loading, setLoading] = useState(true);
  const [primaryData, setPrimaryData] = useState({});
  const [secondaryData, setSecondaryData] = useState({});

  const getData = () => {
    setLoading(true);

    ApiService.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}`).then(response => {
      const { data } = response.data;

      const primary = {};
      const secondary = {};
      data.slice(0, 6).forEach(listItem => {
        primary[listItem[0]] = listItem[1];
      });
      setPrimaryData(primary);

      data.slice(6).forEach(listItem => {
        secondary[listItem[0]] = listItem[1];
      });
      setSecondaryData(secondary);

      setLoading(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="modal-list-container">
      <Row>
        <Col md={8}>
          <ModalList data={primaryData} columns={1} />
        </Col>
        <Col md={4}>
          <div className="text-center">
            <StaticMap address={`${primaryData.Address} ${primaryData['City, State, Zip']}`} />
          </div>
        </Col>
      </Row>
      <ModalList data={secondaryData} />
    </div>
  );
};

ModalCustomerDetail.propTypes = {
  lookupKey: PropTypes.string,
  view: PropTypes.string,
};

export default ModalCustomerDetail;
